/**
 * TTStats Theme Colors
 * These colors match the mobile app's theme from Theme.kt exactly
 */

// Primary Brand Colors
export const BluePrimary = '#1C7AD6';
export const BluePrimaryVariant = '#64B5F6';

// Accent Colors
export const RedOne = '#C5283D';
export const OrangeOne = '#F59E0B';
export const GreenOne = '#059669';
export const PurpleOne = '#9C27B0';
export const TealOne = '#00ACC1';

// Classification/Rank Colors
export const AColor = '#1A1A1A'; // Soft black for elite A-class
export const BColor = '#9C27B0'; // Purple for B-class
export const CColor = '#F59E0B'; // Vibrant orange for C-class
export const DColor = '#1C7AD6'; // Blue for entry-level D-class

// Special Purpose Colors
export const GoldColor = '#F59E0B'; // Using orange for better contrast
export const ProBadgeColor = '#F59E0B'; // Same as OrangeOne

// Helper function to get classification color
export const getClassificationColorByLetter = (letter: string): string => {
  switch (letter.toUpperCase()) {
    case 'A':
      return AColor;
    case 'B':
      return BColor;
    case 'C':
      return CColor;
    case 'D':
      return DColor;
    default:
      return BluePrimary;
  }
};

// Podium/Medal Colors (for rankings)
export const PodiumColors = {
  first: OrangeOne,    // Gold (#F59E0B) for 1st place
  second: '#9CA3AF',   // Silver/Gray for 2nd place
  third: '#C5283D',    // Bronze/Red for 3rd place
};
